/* ============================================
   TEXTES DU PANIER (FR / EN / AR)
   ============================================ */
var AM_CART_TXT = (function () {
  var l = (document.documentElement.lang || 'fr').slice(0, 2);
  var T = {
    fr: { add: 'Ajouter', added: 'Ajouté', addAria: 'Ajouter au panier', promo: function (c) { return '✓ Code « ' + c + ' » appliqué au paiement'; } },
    en: { add: 'Add', added: 'Added', addAria: 'Add to cart', promo: function (c) { return '✓ Code “' + c + '” applied at checkout'; } },
    ar: { add: 'إضافة', added: 'تمت الإضافة', addAria: 'أضيفي إلى السلة', promo: function (c) { return '✓ تم تطبيق الرمز « ' + c + ' » عند الدفع'; } }
  };
  return T[l] || T.fr;
})();

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    // rebind overlay à chaque ouverture (fix clic-dehors PC)
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.removeEventListener('click', this._closeBound);
      this._closeBound = this.close.bind(this);
      overlay.addEventListener('click', this._closeBound);
    }

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* ============================================
   CODE PROMO (mémorise + applique au checkout)
   ============================================ */
(function () {
  'use strict';
  const PROMO_KEY = 'amiraati_promo';

  function initPromo() {
    const input = document.getElementById('CartDrawer-Promo');
    const btn = document.getElementById('CartDrawer-PromoBtn');
    const feedback = document.getElementById('CartDrawer-PromoFeedback');
    const checkout = document.getElementById('CartDrawer-Checkout');
    if (!input || !btn) return;
    if (input.dataset.bound) return; // évite les doubles bindings au re-render
    input.dataset.bound = '1';

    let saved = '';
    try { saved = localStorage.getItem(PROMO_KEY) || ''; } catch (e) {}
    if (saved) {
      input.value = saved;
      if (feedback) feedback.textContent = AM_CART_TXT.promo(saved);
    }

    function apply() {
      const code = input.value.trim();
      if (!code) {
        try { localStorage.removeItem(PROMO_KEY); } catch (e) {}
        if (feedback) feedback.textContent = '';
        return;
      }
      try { localStorage.setItem(PROMO_KEY, code); } catch (e) {}
      if (feedback) feedback.textContent = AM_CART_TXT.promo(code);
    }

    btn.addEventListener('click', apply);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); apply(); }
    });

    if (checkout && checkout.form) {
      checkout.form.addEventListener('submit', function (e) {
        let code = '';
        try { code = localStorage.getItem(PROMO_KEY) || ''; } catch (err) {}
        if (code) {
          e.preventDefault();
          window.location.href = '/checkout?discount=' + encodeURIComponent(code);
        }
      });
    }
  }

  initPromo();
  document.addEventListener('DOMContentLoaded', initPromo);
  // Le drawer est re-render à chaque update : on ré-initialise après un court délai
  document.addEventListener('cart:refresh', function () { setTimeout(initPromo, 100); });
  document.addEventListener('shopify:section:load', initPromo);
  // Observe le re-render du drawer pour re-binder
  const drawerNode = document.querySelector('cart-drawer');
  if (drawerNode && window.MutationObserver) {
    new MutationObserver(function () { setTimeout(initPromo, 50); })
      .observe(drawerNode, { childList: true, subtree: true });
  }
})();

/* ============================================
   JAUGE FRANCO — remplissage animé
   ============================================ */
(function () {
  'use strict';
  function animateFranco() {
    var fill = document.querySelector('.cart-franco__fill');
    if (!fill) return;
    var target = parseInt(fill.dataset.target || '0', 10);
    // double rAF pour garantir que le 0% est peint avant la transition
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        fill.style.width = target + '%';
      });
    });
  }

  animateFranco();
  document.addEventListener('DOMContentLoaded', animateFranco);
  document.addEventListener('shopify:section:load', animateFranco);

  var drawerNode = document.querySelector('cart-drawer');
  if (drawerNode && window.MutationObserver) {
    new MutationObserver(function () { setTimeout(animateFranco, 50); })
      .observe(drawerNode, { childList: true, subtree: true });
  }
})();

/* ============================================
   CROSS-SELL v2 — carousel premium
   (scroll natif, flèches, pagination compteur + ligne)
   ============================================ */
(function () {
  'use strict';

  function money(cents) {
    return (cents / 100).toLocaleString('fr-FR', {
      style: 'currency',
      currency: window.Shopify ? Shopify.currency.active : 'EUR'
    });
  }

  function escapeAttr(str) {
    return (str || '').replace(/"/g, '&quot;');
  }

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function buildSlide(p) {
    var img1 = p.featured_image || '';
    var img2 = p.featured_image_2 || '';
    var slide = document.createElement('div');
    slide.className = 'cart-xsell-slide';

    var img2html = img2
      ? '<img class="cart-xsell-slide__img2" src="' + img2 + '&width=700" alt="" loading="lazy">'
      : '';

    slide.innerHTML =
      '<a href="' + p.url + '" class="cart-xsell-slide__media">' +
        (img1 ? '<img class="cart-xsell-slide__img1" src="' + img1 + '&width=700" alt="' + escapeAttr(p.title) + '" loading="lazy">' : '') +
        img2html +
        '<div class="cart-xsell-slide__bar">' +
          '<div class="cart-xsell-slide__txt">' +
            '<span class="cart-xsell-slide__name">' + p.title + '</span>' +
            '<span class="cart-xsell-slide__price">' + money(p.price) + '</span>' +
          '</div>' +
          '<button type="button" class="cart-xsell-slide__add" data-variant-id="' + p.variant_id + '" aria-label="' + AM_CART_TXT.addAria + '">' +
            '<svg class="cart-xsell-slide__ico-plus" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>' +
            '<svg class="cart-xsell-slide__ico-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg>' +
            '<svg class="cart-xsell-slide__spinner" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>' +
          '</button>' +
        '</div>' +
      '</a>';
    return slide;
  }

  function wireInlineAdd(container, product) {
    var btn = container.querySelector('.cart-xsell-inline__add');
    if (!btn) return;
    var lpCart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var vid = btn.dataset.variantId;
      if (!vid || btn.classList.contains('is-loading') || btn.classList.contains('is-done')) return;
      btn.classList.add('is-loading');

      var config = (typeof fetchConfig === 'function') ? fetchConfig('javascript') : { method: 'POST', headers: {} };
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      var fd = new FormData();
      fd.append('id', vid);
      fd.append('quantity', 1);
      fd.append('properties[_source]', 'Suggestion panier');
      if (lpCart && lpCart.getSectionsToRender) {
        fd.append('sections', lpCart.getSectionsToRender().map(function (s) { return s.id; }));
        fd.append('sections_url', window.location.pathname);
      }
      config.body = fd;

      fetch(window.routes.cart_add_url, config)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          btn.classList.remove('is-loading');
          if (data.status) {
            btn.classList.add('is-error');
            setTimeout(function () { btn.classList.remove('is-error'); }, 1600);
            return;
          }
          btn.classList.add('is-done');
          btn.textContent = AM_CART_TXT.added;
          setTimeout(function () {
            if (lpCart && lpCart.renderContents) lpCart.renderContents(data);
          }, 700);
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.classList.add('is-error');
          setTimeout(function () { btn.classList.remove('is-error'); }, 1600);
        });
    });
  }
  function initXsell() {
    var openBtn = document.getElementById('CartXsell-Open');
    var closeBtn = document.getElementById('CartXsell-Close');
    var panel = document.getElementById('CartXsell-Panel');
    var track = document.getElementById('CartXsell-Track');
    var prevBtn = document.getElementById('CartXsell-Prev');
    var nextBtn = document.getElementById('CartXsell-Next');
    var countEl = document.getElementById('CartXsell-Count');
    var fillEl = document.getElementById('CartXsell-ProgressFill');
    var paginationWrap = document.getElementById('CartXsell-Pagination');
    var thumbsWrap = document.getElementById('CartXsell-Thumbs');
    if (!openBtn || !panel || !track) return;
    if (openBtn.dataset.bound) return; // évite les doubles bindings au re-render
    openBtn.dataset.bound = '1';

    var pid = panel.dataset.productId;
    if (!pid) return;

    var activeIndex = 0;

    fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var cartIds = (panel.dataset.cartIds || '').split(',').filter(Boolean);
        var seen = {};
        cartIds.forEach(function (id) { seen[id] = 1; });

        var products = [];

        // 1. Recos API d'abord (hors panier)
        if (data && data.products) {
          data.products.forEach(function (p) {
            if (seen[p.id]) return;
            seen[p.id] = 1;
            products.push({
              id: p.id, title: p.title, url: p.url, price: p.price,
              featured_image: p.featured_image || (p.images && p.images[0]) || '',
              featured_image_2: (p.images && p.images[1]) ? p.images[1] : '',
              variant_id: p.variants && p.variants[0] ? p.variants[0].id : ''
            });
          });
        }

        // 2. Compléter avec le stock (hors panier, hors déjà ajouté)
        var fbNode = document.getElementById('CartXsell-Fallback');
        if (fbNode) {
          try {
            JSON.parse(fbNode.textContent).forEach(function (p) {
              if (seen[p.id] || products.length >= 12) return;
              seen[p.id] = 1;
              products.push(p);
            });
          } catch (e) {}
        }

        if (!products.length) return;

        track.innerHTML = '';
        products.forEach(function (p) { track.appendChild(buildSlide(p)); });

        var multi = products.length > 1;
        track.classList.toggle('is-single', products.length === 1);
        track.classList.toggle('is-double', products.length === 2);
        if (prevBtn) prevBtn.style.display = multi ? 'flex' : 'none';
        if (nextBtn) nextBtn.style.display = multi ? 'flex' : 'none';
        if (paginationWrap) paginationWrap.style.display = multi ? 'flex' : 'none';

        if (thumbsWrap) {
          thumbsWrap.innerHTML = '';
          products.slice(0, 3).forEach(function (p) {
            if (!p.featured_image) return;
            var t = document.createElement('span');
            t.className = 'cart-xsell-trigger__thumb';
            t.innerHTML = '<img src="' + p.featured_image + '&width=120" alt="" loading="lazy">';
            thumbsWrap.appendChild(t);
          });
        }

        // Affichage inline : une seule suggestion, directement dans le cart
        var inline = document.getElementById('CartXsell-Inline');
        var inlineItem = document.getElementById('CartXsell-InlineItem');
        if (inline && inlineItem && products[0]) {
          var p = products[0];
          var img = p.featured_image || '';
          inlineItem.innerHTML =
            '<a href="' + p.url + '" class="cart-xsell-inline__media">' +
              (img ? '<img src="' + img + '&width=200" alt="' + escapeAttr(p.title) + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="cart-xsell-inline__info">' +
              '<span class="cart-xsell-inline__name">' + p.title + '</span>' +
              '<span class="cart-xsell-inline__price">' + money(p.price) + '</span>' +
            '</div>' +
            '<button type="button" class="cart-xsell-inline__add" data-variant-id="' + p.variant_id + '" aria-label="' + AM_CART_TXT.addAria + '">' + AM_CART_TXT.add + '</button>';
          inline.style.display = 'block';
          wireInlineAdd(inlineItem, p);
        }

        // On garde le panneau fonctionnel mais caché (ne pas afficher le bouton)
        wireCarousel();
        wireAddButtons();
      })
      .catch(function () {});

    openBtn.addEventListener('click', function () {
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      // les rects sont à 0 tant que le panneau est invisible : on recalcule une fois ouvert
      requestAnimationFrame(function () { requestAnimationFrame(updateActive); });
    });
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
      });
    }

  function updateActive() {
  var slides = track.querySelectorAll('.cart-xsell-slide');
  if (!slides.length) return;

  var trackRect = track.getBoundingClientRect();
  var centerX = trackRect.left + trackRect.width / 2;
  var bestIdx = 0, bestDist = Infinity;

  slides.forEach(function (s, i) {
    var r = s.getBoundingClientRect();
    var dist = Math.abs((r.left + r.width / 2) - centerX);
    if (dist < bestDist) { bestDist = dist; bestIdx = i; }
  });

  slides.forEach(function (s, i) {
    s.classList.toggle('is-active', i === bestIdx);
  });

  activeIndex = bestIdx;
  var total = slides.length;

  // Compteur texte
  if (countEl) countEl.textContent = pad(bestIdx + 1) + ' / ' + pad(total);

  // Jauge : on force le style directement sur l'élément, sans dépendre du CSS
  var fill = document.getElementById('CartXsell-ProgressFill');
  if (fill) {
    var pct = total <= 1 ? 100 : Math.round((bestIdx / (total - 1)) * 100);
    fill.style.cssText = [
      'display: block',
      'position: absolute',
      'left: 0',
      'top: 0',
      'bottom: 0',
      'height: 100%',
      'border-radius: 2px',
      'background: linear-gradient(90deg, #B98A99, #E6CCD5)',
      'transition: width 0.35s cubic-bezier(0.4,0,0.2,1)',
      'width: ' + pct + '%'
    ].join(';');
  }

  if (prevBtn) prevBtn.classList.toggle('is-disabled', bestIdx === 0);
  if (nextBtn) nextBtn.classList.toggle('is-disabled', bestIdx === total - 1);
}

    function goTo(idx) {
      var slides = track.querySelectorAll('.cart-xsell-slide');
      idx = Math.max(0, Math.min(idx, slides.length - 1));
      var target = slides[idx];
      if (!target) return;
      // scrollIntoView gère le smooth + le centrage nativement, aucun calcul manuel
      target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    function wireCarousel() {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { updateActive(); ticking = false; });
      }, { passive: true });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateActive, 150);
      });

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(activeIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(activeIndex + 1); });

      requestAnimationFrame(function () { requestAnimationFrame(updateActive); });
    }

    function wireAddButtons() {
      var lpCart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      track.querySelectorAll('.cart-xsell-slide__add').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();          // ne pas suivre le lien produit
          e.stopPropagation();
          var vid = btn.dataset.variantId;
          if (!vid || btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
          btn.classList.add('is-loading');

          var config = (typeof fetchConfig === 'function') ? fetchConfig('javascript') : { method: 'POST', headers: {} };
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          var fd = new FormData();
          fd.append('id', vid);
          fd.append('quantity', 1);
          fd.append('properties[_source]', 'Carrousel panier');
          if (lpCart && lpCart.getSectionsToRender) {
            fd.append('sections', lpCart.getSectionsToRender().map(function (s) { return s.id; }));
            fd.append('sections_url', window.location.pathname);
          }
          config.body = fd;

          fetch(window.routes.cart_add_url, config)
            .then(function (r) { return r.json(); })
            .then(function (data) {
              btn.classList.remove('is-loading');

              if (data.status) {
                btn.classList.add('is-error');
                setTimeout(function () { btn.classList.remove('is-error'); }, 1600);
                return;
              }

              btn.classList.add('is-added');
              setTimeout(function () {
                if (lpCart && lpCart.renderContents) lpCart.renderContents(data);
              }, 900);
            })
            .catch(function () {
              btn.classList.remove('is-loading');
              btn.classList.add('is-error');
              setTimeout(function () { btn.classList.remove('is-error'); }, 1600);
            });
        });
      });
    }
  }

  initXsell();
  document.addEventListener('DOMContentLoaded', initXsell);
  document.addEventListener('shopify:section:load', initXsell);
  var drawerNode = document.querySelector('cart-drawer');
  if (drawerNode && window.MutationObserver) {
    new MutationObserver(function () { setTimeout(initXsell, 50); })
      .observe(drawerNode, { childList: true, subtree: true });
  }
})();
